import styled from 'styled-components';

export const ContentWrapper = styled.div`
`;

export const ContentTypes = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text {
    font-size: 1.4rem;
    color: gray;
    margin: 1rem;
  }
  input {
    width: 30rem;
    height: 5rem;
    border: none;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 1rem;
    margin: 1rem;
    padding: 2rem;
    font-size: 1.3rem;
  }
  .input {
    width: 30rem;
    height: 5rem;
    border: none;
    box-shadow: 0px 3px 6px 1px rgb(0 0 0 / 16%);
    border-radius: 1rem;
    margin: 1rem;
    padding: 2rem;
    font-size: 1.3rem;
    position: relative;
    display: flex;
    align-items: center;
    i {
      font-size: 1.8rem;
      position: absolute;
      right: 2rem;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/components/styles.js